import { formatDuration, riyadhTime } from '@room-verify/shared';
import type { CompletionResult } from '../api';
import { Button, IconCheckCircle, IconClock, IconPlus } from '../components';
import type { Copy } from '../i18n';

export function SuccessScreen({
  copy,
  result,
  onNext,
}: {
  copy: Copy;
  result: CompletionResult;
  onNext: () => void;
}) {
  return (
    <div className="screen success-screen">
      <div className="success-card">
        <span className="success-icon" aria-hidden="true">
          <IconCheckCircle size={40} />
        </span>

        <h2 className="success-title">{copy.inspectionCompleted}</h2>

        <p className="success-room">
          {copy.roomNumber} <strong className="num">{result.roomNumber}</strong>
        </p>

        <p className="success-sent">{copy.reportSent}</p>

        <dl className="success-meta">
          <div>
            <dt>{copy.durationLabel}</dt>
            <dd className="num">{formatDuration(result.durationSeconds)}</dd>
          </div>
          <div>
            <dt>
              <IconClock size={13} />
            </dt>
            <dd className="num">{riyadhTime(result.completedAt)}</dd>
          </div>
        </dl>

        {!result.itemsComplete && (
          <div className="success-missing">
            <p className="success-missing-title">{copy.missingItems}</p>
            <ul className="success-missing-list">
              {result.missingItems.map((item) => (
                <li key={item} lang="en" dir="ltr">
                  {item}
                </li>
              ))}
              {result.otherMissingItem && (
                <li>
                  {copy.otherItem}: {result.otherMissingItem}
                </li>
              )}
            </ul>
          </div>
        )}
      </div>

      <div className="sticky-actions">
        <Button variant="accent" size="lg" block onClick={onNext} icon={<IconPlus size={18} />}>
          {copy.checkAnotherRoom}
        </Button>
      </div>
    </div>
  );
}
